const METHODS = ["VISA", "Mastercard", "PayPal", "Klarna"];

export function PaymentBadges({ compact = false }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "mt-4"}`} data-testid="payment-badges">
      {!compact && (
        <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground mr-1">Pagamenti sicuri:</span>
      )}
      {METHODS.map((m) => (
        <span key={m}
          className="text-xs font-black tracking-wide px-3 py-1.5 rounded-full border border-border bg-card text-foreground/80">
          {m}
        </span>
      ))}
      <span className="text-xs text-muted-foreground">anche in 3 rate senza interessi</span>
    </div>
  );
}
